import { CharacterNameValues } from '../Character';
import { Level, LevelNameValues, LevelPurchaseDetails } from './levels/level';

// Static settings.
export interface RunSettings {
  // startWorldId: WorldNameValues;
  [RunSettingsHandler.keys.InstantRestart]: boolean;
  [RunSettingsHandler.keys.RegenOnRestart]: boolean;
  [RunSettingsHandler.keys.SelectedCharacter]: CharacterNameValues;
  [RunSettingsHandler.keys.SelectedLevel]: LevelNameValues;
  [RunSettingsHandler.keys.LevelPurchaseDetails]?: Record<LevelNameValues, LevelPurchaseDetails>;
}

// Values that need to change over the course of play e.g. player lives.
export interface RunSettingsActive extends RunSettings {}

/**
 * Stores a copy of any provided RunSettings in the scene's registry and can
 * rest them back to the original values.
 */
export class RunSettingsHandler {
  public static keys = {
    InstantRestart: 'instantRestart',
    RegenOnRestart: 'regenOnRestart',
    SelectedCharacter: 'selectedCharacter',
    SelectedLevel: 'selectedLevel',
    LevelPurchaseDetails: 'levelPurchaseDetails'
  } as const;

  public static events = {} as const;

  protected scene: Phaser.Scene;
  protected runSettings: RunSettings;

  constructor(scene: Phaser.Scene, runSettings: RunSettings) {
    this.scene = scene;
    this.runSettings = runSettings;

    this.resetData();
  }

  public resetData() {
    let settings: RunSettingsActive = Object.assign({}, this.runSettings);

    this.scene.registry.set(settings);
  }

  public static getSelectedCharacter(scene: Phaser.Scene): CharacterNameValues {
    return scene.registry.get(RunSettingsHandler.keys.SelectedCharacter);
  }

  public static getSelectedLevel(scene: Phaser.Scene): LevelNameValues {
    return scene.registry.get(RunSettingsHandler.keys.SelectedLevel);
  }

  public static getNextLevelDetails(scene: Phaser.Scene, levelId: LevelNameValues): LevelPurchaseDetails {
    let details: Record<LevelNameValues, LevelPurchaseDetails> = scene.registry.get(RunSettingsHandler.keys.LevelPurchaseDetails);
    return details[levelId];
  }

  public static getNextLevel(scene: Phaser.Scene, levelId: LevelNameValues): LevelNameValues | undefined {
    let details: Record<LevelNameValues, LevelPurchaseDetails> = scene.registry.get(RunSettingsHandler.keys.LevelPurchaseDetails);
    return details?.[levelId].nextLevel;
  }

  public static getNextLevelUnlockCost(scene: Phaser.Scene, levelId: LevelNameValues): number | undefined {
    let details: Record<LevelNameValues, LevelPurchaseDetails> = scene.registry.get(RunSettingsHandler.keys.LevelPurchaseDetails);
    return details?.[levelId].nextLevelPrice;
  }
}
